/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import CreateEventAbstract from 'cio/app-models/action-abstracts/create-event';
import ApiService from 'cio/services/api';
import ApiErrorsService from 'cio/services/api-errors';
import DS from 'ember-data';

interface CreateEventEditSidebarEditorArgs {
  actionAbstract: CreateEventAbstract;
  isSaving: boolean;
  onSelect: () => unknown;
  onDeselect: () => unknown;
  hasReadOnlyPermission: boolean;
}

export default class CreateEventEditSidebarEditor extends Component<CreateEventEditSidebarEditorArgs> {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;
  @service store!: DS.Store;
}
